import {
    getApiUserNotifications,
    getApiUserNotificationsUnreadCount,
    patchApiUserNotificationsRead,
    postApiUserNotificationsReadAll,
    getApiAdminNotifications,
    getApiOperatorNotifications,
} from '../../../generated/apiClient';

/**
 * Notifications API
 * Handles notification inbox, unread counts, and mark-as-read operations.
 */

const normalizeList = (response) => {
    if (!response || !response.success) {
        return { messages: [], total: 0, unreadCount: 0 };
    }
    return {
        messages: response.data?.messages || [],
        total: response.data?.total || 0,
        unreadCount: response.data?.unreadCount || 0,
    };
};

export const notificationsApi = {
    /**
     * Get the current user's notifications (in-app inbox)
     * @param {Object} params - Query parameters
     */
    async getMy(params = {}) {
        const response = await getApiUserNotifications({
            params: {
                category: params.category,
                channel: params.channel,
                unreadOnly: params.unreadOnly,
                limit: params.limit || 10,
                offset: params.offset || 0,
            },
        });
        return normalizeList(response);
    },

    /**
     * Get the current user's unread notification count
     * @returns {Promise<number>}
     */
    async getUnreadCount() {
        const response = await getApiUserNotificationsUnreadCount();
        return response?.data?.unreadCount || 0;
    },

    /**
     * Mark a notification as read
     * @param {number} id - Notification message id
     */
    async markRead(id) {
        return await patchApiUserNotificationsRead(id);
    },

    /**
     * Mark all notifications as read
     */
    async markAllRead() {
        return await postApiUserNotificationsReadAll();
    },

    /**
     * List recently sent notifications (admin/operator monitoring view)
     * @param {string} scope - 'admin' | 'operator'
     * @param {Object} params - Query parameters
     */
    async getSentList(scope, params = {}) {
        const fn = scope === 'admin'
            ? getApiAdminNotifications
            : getApiOperatorNotifications;

        const response = await fn({
            params: {
                userId: params.userId,
                category: params.category,
                channel: params.channel,
                status: params.status,
                limit: params.limit || 10,
                offset: params.offset || 0,
            },
        });
        return normalizeList(response);
    },
};

export default notificationsApi;
